module.exports = __webpack_public_path__ + "static/media/game_clear_image.9438fa08.png";